<style>
@media (max-width: 960px) {
  .session-info-wrap{
    width: 100% !important;
  }
}

.uk-icon-link {
  position: absolute;
}

</style>

<template lang="html">
  <div class="uk-margin-top">
    <hr class="uk-wdith uk-divider-icon">
    <div>
      <h3 class="uk-padding-remove">Moje wizyty <div id="visitLoader" uk-spinner></div></h3>
    </div>
    <div class="uk-overflow-auto table-holder">
      <table class="uk-table uk-table-middle uk-table-divider uk-margin-remove-top uk-table-hover">
        <thead>
            <tr>
                <th @click="sortBy('data')" style="min-width: 85px;">Data
                  <i v-if="orderKey == 'data'" class="uk-icon-link" v-bind:uk-icon="this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down'" aria-hidden="true"></i>
                </th>
                <th>Godzina
                </th>
                <th @click="sortBy('status')" class="uk-visible@m">Status
                  <i v-if="orderKey == 'status'" class="uk-icon-link" v-bind:uk-icon="this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down'" aria-hidden="true"></i>
                  </th>
                <th @click="sortBy('doctor')" class="uk-visible@m">Lekarz
                  <i v-if="orderKey == 'doctor'" class="uk-icon-link" v-bind:uk-icon="this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down'" aria-hidden="true"></i>

                </th>
                <th @click="sortBy('reason')" class="uk-visible@m">Powód wizyty
                  <i v-if="orderKey == 'reason'" class="uk-icon-link" v-bind:uk-icon="this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down'" aria-hidden="true"></i>

                </th>
                <th @click="sortBy('position')" class="uk-visible@m" style="width: 1px; text-align: center;">
                    Numer w kolejce
                    <i v-if="orderKey == 'position'" class="uk-icon-link" v-bind:uk-icon="this.orderDir === 'asc' ? 'arrow-up' : 'arrow-down'" aria-hidden="true"></i>
                </th>
                <th>Dostępne działania

                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="visit in visits">
                <td>{{ visit.data | formatDate }}</td>
                <td>{{ visit.data | formatTime }}</td>
                <td class="uk-visible@m">
                  <span v-if="visit.status === 'zarejestrowana'" class="uk-label uk-label-primary">{{ visit.status }}</span>
                  <span v-else class="uk-label uk-label-warning">{{ visit.status }}</span>
                </td>
                <td class="uk-visible@m">{{ visit.doctor }} {{ visit.specjalizacja }}</td>
                <td class="uk-visible@m">{{ visit.reason }}</td>
                <td class="uk-visible@m" style="text-align: center;">
                  <span v-if="visit.position === '-1'">-</span>
                  <span v-else>{{ visit.position }}</span>
                </td>
                <td class="uk-button-group">
                  <router-link :to="{ name: 'visit', params: {visitId: visit.idrejestracja, status: visit.status, ankieta: visit.ankieta, reason: visit.reason, doctor: visit.doctor, data: visit.data, position: visit.position, adres1: visit.adres1, adres2: visit.adres2, information: visit.info, type: visit.type, cena: visit.cena} }">
                    <button v-if="visit.idrejestracja" class="see-more-btn uk-button uk-button-primary" type="button" title="Otwórz pełen widok wizyty" uk-tooltip="pos: bottom">
                      <!-- <span uk-icon="icon: expand"></span> -->
                      Zobacz
                    </button>
                  </router-link>
                </td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import $ from 'jquery'
import UIkit from 'uikit'
export default {
  name: 'main',
  orderKey: '',
  orderDir: 'asc',
  data () {
    return {
      visits: [
        {
          'title': '',
          'link': '',
          'data': '',
          'reason': '',
          'doctor': '',
          'specjalizacja': '',
          'status': '',
          'type': '',
          'position': '',
          'idrejestracja': '',
          'ankieta': ''
        }
      ]
    }
  },
  mounted: function () {
    this.$root.$on('refreshMain', () => {
      this.getData()
    })
    this.getData()
  },
  methods: {
    sortBy (sortKey) {
      if (this.orderKey === sortKey) {
        this.orderDir = this.orderDir === 'asc' ? 'desc' : 'asc'
      } else {
        this.orderDir = 'asc'
      }
      this.orderKey = sortKey
      var visitsArr = this.visits
      var sortedVisits = _.orderBy(visitsArr, sortKey, this.orderDir)
      this.visits = sortedVisits
    },
    getData () {
      $('#sliderMain').css('display', 'block')
      $('#backbtn').css('display', 'none')
      $('#notifications').css('display', 'block')
      $('#visitLoader').css('display', 'inline-block')
      $('.session-info-wrap').css('width', '50%')
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut')
        var getVisitsMetod = { 'input': { 'status': '', 'data': { 'TOKEN': token } } }
        // var getVisitsMetod = {'input': {'status': '', 'data': {'TOKEN': 123}}}
        // TODO: Zaciągać API URL z XML
        this.$http.post('/api.php?url=getVisits', getVisitsMetod, { headers: { 'Content-Type': 'application/json' } }).then((response) => {
          var resp = response.data
          var visits = resp.d.data
          /* check if api OK but data is empty
          if (JSON.stringify(visits) && JSON.stringify(visits) === '[]') {
            UIkit.modal.alert('Brak wizyt')
          }
          */
          this.visits = visits
          this.orderDir = 'desc'
          this.orderKey = 'data'
          $('#visitLoader').css('display', 'none')
        }).catch((errors) => {
          // JSON.stringify(errors)
          UIkit.modal.alert('Coś poszło nie tak... Kod: ' + errors.status)
          $('#visitLoader').css('display', 'none')
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>

  .table-holder
    max-height: 400px
    overflow-y: scroll

  .func-btn
    width: 40px
    padding: 0 10px

  tr
    cursor: pointer

  .see-more-btn

    @media screen and (max-width: 555px)
      height: 50px

    @media screen and (max-width: 430px)
      height: 71px

</style>



// WEBPACK FOOTER //
// Main.vue?86e497e2